import { useState, useEffect } from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import SpaceScene from './SpaceScene'
import styles from './Hero.module.css'

const Hero = () => {
  const { t } = useLanguage()
  const [currentSlide, setCurrentSlide] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev >= 6 ? 1 : prev + 1))
    }, 5000) // 5 saniye

    return () => clearInterval(interval)
  }, [])

  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault()
    const element = document.getElementById(sectionId)
    if (element) {
      const targetPosition = element.offsetTop - 80
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }

  return (
    <section id="home" className={styles.hero}>
      <div className={styles.spaceBackground}>
        <SpaceScene />
      </div>
      <div className={styles.easterEgg}>
        <span>emre başa selam olsun</span>
      </div>
      <div className={styles.heroContent}>
        <div className={styles.heroText}>
          <h1 className={styles.heroTitle} key={currentSlide}>
            <span className={styles.titleLine}>{t(`hero.slide${currentSlide}.title`)}</span>
          </h1>
          <p className={styles.heroSubtitle} key={`subtitle-${currentSlide}`}>
            {t(`hero.slide${currentSlide}.subtitle`)}
          </p>
          <div className={styles.heroCtaGroup}>
            <a href="#portfolio" className={styles.ctaButton} onClick={(e) => scrollToSection(e, 'portfolio')}>
              {t('hero.cta1')}
            </a>
            <a href="#packages-preview" className={`${styles.ctaButton} ${styles.secondary}`} onClick={(e) => scrollToSection(e, 'packages-preview')}>
              {t('hero.cta2')}
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
